<div class="login-body">
  <div class="login-panel p-fluid">
    <div class="p-grid">
      <div class="p-col-12 logo-container">
        <img [src]="assestBaseUrl + 'layout/images/lionO360_logo1.png'"  alt="logo-dark" />
        <h1>Reset Password</h1>
      </div>

            <div class="p-col-12" *ngIf="!linkExpired && !showSuccessMessage">
                <form [formGroup]="resetPasswordForm" (ngSubmit)="onForgotPasswordSubmit()">
                    <div class="form-group p-mb-2">
                        <label for="newPassword">New Password</label>
                        <input pInputText [type]="showPassword ? 'text' : 'password'" formControlName="newPassword"
                            class="form-control" (input)="onPasswordInput()" />
                        <i *ngIf="showEyeIcon" [ngClass]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
                            style="position: absolute; margin-top: 12px; margin-left: -18px;"
                            (click)="showPassword = !showPassword;"></i>
                        <div *ngIf="detailsFormErrors?.newPassword" class="p-invalid p-mb-2">
                            <small>{{ detailsFormErrors?.newPassword}}</small>
                        </div>
                    </div>
                    <div class="form-group p-mb-2">
                        <label for="confirmNewPassword">Confirm New Password</label>
                        <input pInputText type="password" formControlName="confirmNewPassword" class="form-control" />
                        <div *ngIf="detailsFormErrors?.confirmNewPassword" class="p-invalid">
                            <small>{{ detailsFormErrors?.confirmNewPassword}}</small>
                        </div>
                        <div>
                            <small class="p-invalid p-mb-2"
                                *ngIf="resetPasswordForm.hasError('validateEqual') && resetPasswordForm.get('confirmNewPassword').touched">Password
                                does not match.</small>
                        </div>
                    </div>
                    <div class="form-group p-mt-3">
                        <button type="submit" pButton label="Reset Password"
                            class="p-button-success p-button-rounded p-button-raised"></button>
                    </div>
                </form>
                <div class="form-group" style="margin-top:30px">
                    <table style="width: 100%;">
                        <tr>
                            <td style="text-align: right;">
                                <div class="p-field-checkbox" style="margin-left: 60px">
                                    <a [routerLink]="['/login']" style="display: flex"><i class="pi pi-arrow-left" style="margin-right: 4px"></i> Back to Login Page</a>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>

            </div>

            <div *ngIf="linkExpired">
                <div class="error-message">
                    <p>Your password reset link has expired. To regain access, kindly request a new one by clicking the link below:</p>
                </div>
                <div class="form-group">
                    <table style="width: 100%;">
                        <tr>
                            <td style="text-align: right;">
                                <div class="p-field-checkbox" style="margin-left: 60px">
                                    <a [routerLink]="['/password']" style="display: flex"><i class="pi pi-arrow-left" style="margin-right: 4px"></i>Back to Reset Page</a>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            
            <div *ngIf="showSuccessMessage">
                <div class="success-message">
                    <p>Password has been reset successfully!</p>
                </div>
                <div class="form-group">
                    <table style="width: 100%;">
                        <tr>
                            <td style="text-align: right;">
                                <div class="p-field-checkbox"  style="margin-left: 60px">
                                    <a [routerLink]="['/login']" style="display: flex"><i class="pi pi-arrow-left" style="margin-right: 4px"></i> Back to Login Page</a>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
